<template lang="pug">
.layout
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card(min-height="80vh")
      v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
        v-row(no-gutters, align="center")
          v-col.shrink
            v-btn.ml-n3(text, icon, @click="showModal = !showModal", height)
              eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.basic800--text {{ $t('reload_credit') }}
      v-card-text
        v-form(ref="form")
          .select-amount.mt-4
            .label.basic600--text.text-uppercase {{ $t('select_reload_amount') }}
            v-row.py-2.mx-0
              div( v-for="(amount,index) in reloadAmountList" :key="index" )
                v-btn.button-AA-medium.defaultBtn.textColorHint--text(:class="{ 'firstBtn' : index== 0, 'lastBtn': index == reloadAmountList.length-1, 'selectedBtn': reloadAmount == amount}" outlined @click="selectAmount(amount), reloadAmount = amount") {{ amount }}.00
          .amount.mt-2
            v-text-field(v-model="reloadAmount" :placeholder="$t('enter_minimum_price')" dense outlined height="40" type="number"  min=5 :rules="rules.min" background-color="basic200" :prefix="$currency.symbol")
          .payment-method.mt-n2
            .selection(v-if="showCardCreditOption")
              .mt-2.label.basic600--text.text-uppercase {{ $t('payment_method') }}
              v-select.mt-2(v-model="form.paymentMethod" :placeholder="$t('select_payment_method')" :items="paymentMethods" item-text="name" item-value="id" background-color="basic200" height="40" outlined dense append-icon="mdi-chevron-down" :rules="rules.is_selected")
                template(v-slot:item="{ item }")
                  v-list-item-content
                    v-list-item-title {{ item.name }}

            v-card.pa-4.mt-2(v-if="form.paymentMethod" flat outlined style="border:1px solid var(--v-basic300);")
              card-list.mt-4(v-if="form.paymentMethod === 'card'" @change="form.card = $event.id")
              .online-payment.mt-4(v-else-if="form.paymentMethod === 'fpx'" )
                div.subtitle.mb-3 {{ $t('choose_bank_for_payment') }}
                v-card.mb-12
                  FPXPicker(v-model="form.fpxBankCode")

      v-card-actions
        v-col.pa-0
          .total(v-if="form.paymentAmount")
            v-layout.px-2
              .p1.primary400--text {{ $t('reload_amount') }}
              v-spacer
              .p1.primary400--text {{ form.paymentAmount | displayPrice }}
            v-layout.px-2
              .p1.primary400--text {{ $t('reload_charge') }}
              v-spacer
              .p1.primary400--text {{ 100 | displayPrice }}
            v-layout.px-2.mt-2
              .h6.primary500--text {{ $t('total_payment') }}
              v-spacer
              .h6.primary500--text {{ form.paymentAmount + 100 | displayPrice }}
          v-layout.mt-4
            v-spacer
            v-btn(color='white', text @click='showModal = !showModal')
              .button-Aa-medium.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(v-if="form.paymentMethod == 'card'" color='info500' depressed @click="clickPayNow" :disabled="!form.card" :loading="isLoading")
              .button-AA-medium.basic100--text {{ $t('pay_now') }}
            v-btn.mr-2(v-else-if="form.paymentMethod == 'fpx'" color='info500' depressed @click="clickPayNow" :disabled="!form.fpxBankCode" :loading="isLoading")
              .button-AA-medium.basic100--text {{ $t('pay_now') }}
            v-btn.mr-2(v-else color='info500' depressed @click="clickPayNow")
              .button-AA-medium.basic100--text {{ $t('pay_now') }}

  .modals
    y-dialog(v-model="openBillWindowDialog" width="400px" persistent)
      v-card
        v-card-title {{ $t('please_pay_to_proceed') }}
        v-card-text.px-6
          div {{ $t('you_will_be_redirected') }}
        v-card-actions
          v-spacer
          v-btn(text @click="openBillWindowDialog = false")
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32 @click='openPaymentPage()')
            .button-AA-small.basic100--text {{ $t('pay_now') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CardList from '@/components/billing/CardList.vue'
import FPXPicker from '@/components/FPXPicker.vue'

export default {
  name: "ReloadCreditDialog",
  components: { CardList, FPXPicker },
  props: ['open', 'refreshPage'],
  data: () => ({
    reloadAmountList: [10,30,50],
    reloadAmount: 0,
    form: {
      paymentAmount: 0,
      paymentMethod: 'fpx',
      card: null,
      fpxBankCode: null
    },
    paymentMethods: [
      { name: 'Credit or debit card', id: 'card'},
      { name: 'Online banking', id: 'fpx'}
    ],
    isLoading: false,
    billUrl: '',
    openBillWindowDialog: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'Item is required', (v) => v != 0|| 'Item is required'],
      is_selected: [(v) => v !== null || 'This field is required'],
      min: [v => v >= 5 || 'Minimum reload amount is RM 5.00']
    },
  }),
  mounted(){
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open;
      },
      set(newValue) {
        this.$emit("update:open", newValue);
      },
    },
    showCardCreditOption () {
      if (window.location.hostname.includes("localhost") || window.location.hostname.includes("arbatravel-test")) {
        return true
      } 
      return false
    }
  },
  watch: {
    reloadAmount (val) {
      this.form.paymentAmount = parseInt((parseFloat(val)).toFixed(this.$currency.exponent).replace('.', ''))
    }
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    btnClass(index,length){
      if (index==0) {
        return 'firstBtn'
      } else if (index==length) {
        return 'lastBtn'
      }
    },
    selectAmount(amount){
      this.reloadAmount = amount
    },
    clickPayNow () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const data = {
        company: this.company.id,
        amount: this.form.paymentAmount
      }
      if (this.form.paymentMethod === 'card') {
        data.card = this.form.card
      } else if (this.form.paymentMethod === 'fpx') {
        data.bank_code = this.form.fpxBankCode
      }
      this.$axios.post('/billing/prepaid_credit_reloads/topup_request/', data)
        .then(resp => {
          if (this.form.paymentMethod === 'card') {
            this.showMessage(['success', this.$t('success_message.reload_successful')])
            this.fetchCompany()
            this.showModal = false
            if (this.refreshPage) {
              window.location.reload()
            }
          } else if (this.form.paymentMethod === 'fpx') {
            this.billUrl = resp.data.bill_url
            if (this.billUrl) {
              window.open(this.billUrl)
              this.showModal = false
              if (this.refreshPage) {
                window.location.reload()
              }
            } else {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
            }
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fetchCompany () {
      this.$axios.get(`/companies/${this.company.id}/`)
        .then(resp => {
          this.updateCompany(resp.data)
        }).catch(() => {})
    },
    openPaymentPage () {
      window.open(this.billUrl, '_blank')
    }
  }
};
</script>

<style scoped>
.defaultBtn {
  border: 1px solid var(--v-textColorHint);
  border-radius: 0;
  box-shadow: none;
}
.selectedBtn {
  background-color: var(--v-primary500);
  border-color: var(--v-primary500);
  color: white !important;
}
.firstBtn {
  border-radius: 4px 0 0 4px;
}
.lastBtn {
  border-radius: 0 4px 4px 0;
}

div >>> .v-btn--active {
  background-color: var(--v-primary500);
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "reload_credit": "Reload Credit",
    "select_reload_amount": "select reload amount",
    "choose_bank_for_payment": "Choose bank for payment",
    "reload_amount": "Reload Amount",
    "reload_charge": "Reload Charge",
    "total_payment": "Total Payment",
    "please_pay_to_proceed": "Please pay to proceed",
    "you_will_be_redirected": "You will be redirected to a payment page after clicking 'Pay Now' button. Please close that page after payment is completed.",
    "enter_minimum_price": "Enter minimum RM 5.00",
    "select_payment_method": "Select payment method"
  },
  "id": {
  }
}
</i18n>
